import classes from "./Accessibility.module.css";
import { Link } from "react-router-dom";

const AccessibilityEn = () => {
  return (
    <div className={`${classes.privacy}`}>
      <div>
        <h2>SECTION 1</h2>
        <h3>ACCESSIBILITY STATEMENT</h3>
        <p>
          The <b>Municipality of the Heroic City of Naoussa</b> is committed to
          making its website:{" "}
          <i>
            <a
              href="https://naoussa.smartiscity.gr"
              target="_blank"
              rel="noreferrer"
            >
              https://naoussa.smartiscity.gr
            </a>
          </i>{" "}
          accessible, in accordance with the provisions of Law 4727/2020
          (Government Gazette 184/A/23-09-2020), Chapter H, "Digital
          Accessibility", which transposes into Greek law Directive (EU)
          2016/2102 of the European Parliament and of the Council of 26 October
          2016 on the accessibility of the websites and mobile applications of
          public sector bodies.
        </p>
        <p>
          This Accessibility Statement applies to the following website:{" "}
          <i>
            <a
              href="https://naoussa.smartiscity.gr"
              target="_blank"
              rel="noreferrer"
            >
              https://naoussa.smartiscity.gr/
            </a>
          </i>
        </p>

        <h4>Compliance status</h4>
        <p>
          The website{" "}
          <i>
            <a
              href="https://naoussa.smartiscity.gr"
              target="_blank"
              rel="noreferrer"
            >
              https://naoussa.smartiscity.gr/
            </a>
          </i>{" "}
          is fully compliant with the Web Content Accessibility Guidelines{" "}
          <b>WCAG 2.1, Level AA</b>.
        </p>

        <h4>Preparation of this Accessibility Statement</h4>
        <p>
          This Accessibility Statement was prepared on <b>21 November 2022</b>.
        </p>
        <p>
          The actual assessment of the website's compliance with the
          requirements of Directive (EU) 2016/2102 was carried out through a
          self-assessment conducted by the public sector body, using the{" "}
          <b>UserWay Website Accessibility Widget</b>.
        </p>
        <p>
          This Statement was last reviewed on <b>21 November 2022</b>.
        </p>

        <h4>Feedback submission and contact details</h4>
        <p>
          In accordance with the provisions of Law 4727/2020, Article 45, any
          interested party has the right to submit comments, request information
          regarding the website's compliance status, or request information that
          is not accessible.
        </p>
        <p>
          Competent service for accessibility matters and for handling requests
          submitted through the feedback mechanism:
        </p>

        <h4>Enforcement procedure</h4>
        <p>
          The competent department of the{" "}
          <b>Municipality of the Heroic City of Naoussa</b> shall respond to the
          interested party in an appropriate manner.
        </p>
        <p>
          If the response to the notification or request is not considered
          satisfactory, the interested party has the right to refer the matter
          to the competent institutional authorities, as provided by law,
          including by submitting a report to the <b>Greek Ombudsman</b> at{" "}
          <a href="https://www.synigoros.gr" target="_blank" rel="noreferrer">
            https://www.synigoros.gr
          </a>
          .
        </p>

        <h2>SECTION 2</h2>
        <h3>Enabling the Accessibility Menu</h3>
        <p>
          The accessibility menu of <i>https://naoussa.smartiscity.gr</i> can be
          activated by clicking on the accessibility menu icon displayed at the
          top of the page. After activating the accessibility menu, please allow
          a few moments for the menu to load fully.
        </p>
        <p>
          <i>https://naoussa.smartiscity.gr</i> remains committed to
          continuously improving the accessibility of its website, in the belief
          that it is our collective moral obligation to ensure seamless,
          accessible, and unhindered use for all users, including those with
          disabilities.
        </p>
        <p>
          As part of our ongoing efforts to continuously improve accessibility
          and resolve accessibility issues, we regularly scan{" "}
          <i>https://naoussa.smartiscity.gr</i> using the{" "}
          <b>UserWay Accessibility Scanner</b> in order to identify and correct
          any potential accessibility barriers on the website. Despite our
          efforts to make all pages and content on{" "}
          <i>https://naoussa.smartiscity.gr/</i> fully accessible, some content
          may not yet have been fully adapted to the strictest accessibility
          standards.
        </p>

        <p style={{ float: "right", fontWeight: 600, marginTop: 20 }}>
          <Link to={"/"}>Return to Home</Link>
        </p>
      </div>
    </div>
  );
};

export default AccessibilityEn;
